import _ from 'lodash';

class URL {
  constructor(url) {
    const urlL = url.split('#')[0];
    const urlParams = {};

    let queryString = urlL.split('?')[1];
    if (!queryString) {
      if (urlL.search('=') !== false) {
        queryString = urlL;
      }
    }
    if (queryString) {
      const keyValuePairs = queryString.split('&');
      for (let i = 0; i < keyValuePairs.length; i++) {
        const keyValuePair = keyValuePairs[i].split('=');
        const paramName = keyValuePair[0];
        const paramValue = keyValuePair[1] || '';

        urlParams[paramName] = decodeURIComponent(paramValue.replace(/\+/g, ' '));
      }
    }

    this.searchParams = urlParams;
  }

  /**
   * Поиск значения параметра по названию. Если параметр встречался в поисковой строке несколько раз,
   * вернет последнее вхождение параметра
   *
   * @param {String} name
   * @return {String}|null
   */
  searchParam(name) {
    if (typeof this.searchParams[name] !== 'undefined') {
      return this.searchParams[name];
    }
    return null;
  }

  applyFilterParams(filterCollection) {
    const filters = [...filterCollection];

    _.forEach(this.searchParams, (param, key) => {
      // eslint-disable-next-line array-callback-return
      filters.map((filter, i) => {
        if (filter.name === key) {
          filters[i].value = param === '1';
        }
      });
    });
    return filters;
  }
}

// eslint-disable-next-line no-undef
const NEW_API_URL = apiUrl;
const dadataApi = `${NEW_API_URL}/address/suggestions/api/4_1/rs`;

export { URL as default, dadataApi };
